import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/homePage/index.vue"),
    },
    {
      path: "/:uuid",
      name: "preview",
      component: () => import("@/preview/index.vue"),
    },
    {
      path: "/:uuid/:url",
      name: "middlePage",
      component: () => import("@/middlePage/index.vue"),
    },
  ],
});

export default router;
